import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationCavernsMobDeathArgs,
  CavernsMobDeathResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation CavernsMobDeath(
  $playerId: String!
  $game_submode: String!
  $mob_deaths: [CavernsMobDeathEventInput!]!
) {
  cavernsMobDeath(
    playerId: $playerId
    game_submode: $game_submode
    mob_deaths: $mob_deaths
  ) {
    death_tile_loot_events {
      deathTileId
      death_tile_loot
    }
    num_remaining_mobs
  }
}`;

export default async function mutationCavernsMobDeath(args: MutationCavernsMobDeathArgs) {
  return await graphqlClient.request<CavernsMobDeathResult>('cavernsMobDeath', mutation, args);
}
